<div class="user-crud mm-page">
  <!-- header: the opened user (or a new one) with its state -->
  <header class="qa-uc-header">
    <span class="qa-uc-avatar" aria-hidden="true">
      <ng-container *ngIf="user?.userId; else newUserIcon">{{initials}}</ng-container>
      <ng-template #newUserIcon><i class="fa fa-user-plus"></i></ng-template>
    </span>
    <div class="qa-uc-title">
      <h2>{{user?.userId ? (displayName || user.email) : _(KEYS.CRUD.NEW_USER)}}</h2>
      <p *ngIf="user?.userId && displayName">{{user.email}}</p>
    </div>
    <div class="qa-uc-pills" *ngIf="user?.userId && hasMfaSupport">
      <span class="qa-uc-pill" [class.qa-uc-pill-on]="user.mfaEnabled">
        <i class="fa" [ngClass]="user.mfaEnabled ? 'fa-shield' : 'fa-unlock-alt'" aria-hidden="true"></i>
        {{user.mfaEnabled ? _(KEYS.CRUD.MFA_ACTIVE) : _(KEYS.CRUD.MFA_INACTIVE)}}
      </span>
    </div>
  </header>

  <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>{{_(KEYS.CRUD.USER_DATA)}}</a>
      <ng-template ngbNavContent>
        <form [formGroup]="userForm" class="user-data card qa-uc-card">
          <input type="hidden" name="userId" formControlName="userId">

          <!-- login -->
          <section class="qa-uc-section">
            <h3 class="qa-uc-section-title">{{_(KEYS.CRUD.SECTION_LOGIN)}}</h3>
            <div class="qa-uc-fields">
              <ng-container *ngIf="!userForm.get('userId').value">
                <div class="form-group qa-uc-span-12">
                  <label for="email">{{_(KEYS.CRUD.USERNAME)}}</label>
                  <input class="form-control" id="email" placeholder="{{_(KEYS.CRUD.ENTER_USERNAME)}}" formControlName="email" name="email"
                         autocomplete="off">
                  <div class="invalid-feedback display" *ngIf="email.dirty && email.errors?.email">{{_(KEYS.CRUD.ENTER_EMAIL)}}</div>
                </div>
                <div class="form-group qa-uc-span-6">
                  <label for="password">{{_(KEYS.CRUD.PASSWORD)}}</label>
                  <input type="password" class="form-control" id="password" placeholder="{{_(KEYS.CRUD.ENTER_PASSWORD)}}"
                         formControlName="password" name="password" autocomplete="new-password">
                </div>
                <div class="form-group qa-uc-span-6">
                  <label for="passwordRepeat">{{_(KEYS.CRUD.REPEAT_PASSWORD)}}</label>
                  <input type="password" class="form-control" id="passwordRepeat" placeholder="{{_(KEYS.CRUD.ENTER_PASSWORD)}}"
                         formControlName="passwordRepeat" name="passwordRepeat" autocomplete="new-password">
                </div>
                <div class="qa-uc-span-12" *ngIf="password.errors?.passwordPolicy || passwordRepeat.errors?.passwordsMatch">
                  <div class="invalid-feedback display" *ngIf="!passwordRepeat.errors?.passwordsMatch && password.errors?.passwordPolicy">
                    {{_(passwordPolicy?.hint)}}
                  </div>
                  <div class="invalid-feedback display" *ngIf="passwordRepeat.errors?.passwordsMatch">{{_(KEYS.CRUD.ENTERED_PASSWORDS_NO_MATCH)}}</div>
                </div>
              </ng-container>

              <div class="form-group qa-uc-span-12" *ngIf="userForm.get('userId').value">
                <label for="emailReadonly">{{_(KEYS.CRUD.USERNAME)}}</label>
                <input class="form-control" id="emailReadonly" name="email" [value]="userForm.get('email').value" readonly>
              </div>
            </div>
          </section>

          <!-- person -->
          <section class="qa-uc-section">
            <h3 class="qa-uc-section-title">{{_(KEYS.CRUD.SECTION_PERSON)}}</h3>
            <div class="qa-uc-fields">
              <div class="form-group qa-uc-span-3">
                <label for="gender">{{_(KEYS.CRUD.SALUTATION)}}</label>
                <select class="form-control" id="gender" name="gender" formControlName="gender">
                  <option value="male">{{_(KEYS.CRUD.SALUTATION_MR)}}</option>
                  <option value="female">{{_(KEYS.CRUD.SALUTATION_MS)}}</option>
                </select>
              </div>
              <div class="form-group qa-uc-span-9">
                <label for="title">{{_(KEYS.CRUD.TITLE)}}</label>
                <input class="form-control" id="title" placeholder="{{_(KEYS.CRUD.EG_PROF_DR)}}" formControlName="title" name="title">
              </div>
              <div class="form-group qa-uc-span-6">
                <label for="firstName">{{_(KEYS.CRUD.FIRSTNAME)}}</label>
                <input class="form-control" id="firstName" placeholder="{{_(KEYS.CRUD.ENTER_FIRSTNAME)}}" formControlName="firstName" name="firstName">
              </div>
              <div class="form-group qa-uc-span-6">
                <label for="lastName">{{_(KEYS.CRUD.LASTNAME)}}</label>
                <input class="form-control" id="lastName" placeholder="{{_(KEYS.CRUD.ENTER_LASTNAME)}}" formControlName="lastName" name="lastName">
              </div>
            </div>
          </section>

          <!-- address -->
          <section class="qa-uc-section">
            <h3 class="qa-uc-section-title">{{_(KEYS.CRUD.SECTION_ADDRESS)}}</h3>
            <div class="qa-uc-fields">
              <div class="form-group qa-uc-span-12">
                <label for="street">{{_(KEYS.CRUD.STREET)}}</label>
                <input class="form-control" id="street" placeholder="{{_(KEYS.CRUD.ENTER_STREET)}}" formControlName="street" name="street">
              </div>
              <div class="form-group qa-uc-span-3">
                <label for="zip">{{_(KEYS.CRUD.ZIP_CODE)}}</label>
                <input class="form-control" id="zip" placeholder="{{_(KEYS.CRUD.ENTER_ZIP_CODE)}}" formControlName="zip" name="zip">
              </div>
              <div class="form-group qa-uc-span-9">
                <label for="city">{{_(KEYS.CRUD.CITY)}}</label>
                <input class="form-control" id="city" placeholder="{{_(KEYS.CRUD.ENTER_CITY)}}" formControlName="city" name="city">
              </div>
            </div>
          </section>

          <!-- organisation -->
          <section class="qa-uc-section">
            <h3 class="qa-uc-section-title">{{_(KEYS.CRUD.SECTION_ORGANISATION)}}</h3>
            <div class="qa-uc-fields">
              <div class="form-group qa-uc-span-6">
                <label for="company">{{_(KEYS.CRUD.COMPANY)}}</label>
                <input class="form-control" id="company" formControlName="company" name="company">
              </div>
              <div class="form-group qa-uc-span-6">
                <label for="consultantProfile">{{_(KEYS.CRUD.CONSULTANT_PROFILE)}}</label>
                <input class="form-control" id="consultantProfile" formControlName="consultantProfile" name="consultantProfile">
              </div>
            </div>
          </section>

          <!-- save bar -->
          <footer class="qa-uc-save-bar">
            <span class="qa-uc-save-state" [class.qa-uc-dirty]="userForm.dirty" role="status" aria-live="polite">
              <i class="fa" [ngClass]="userForm.dirty ? 'fa-circle' : 'fa-check'" aria-hidden="true"></i>
              {{userForm.dirty ? _(KEYS.CRUD.UNSAVED_CHANGES) : _(KEYS.CRUD.NO_UNSAVED_CHANGES)}}
            </span>
            <div class="qa-uc-save-actions">
              <button type="button" class="btn btn-outline-primary" [disabled]="userForm.get('email').invalid"
                      *ngIf="!userForm.get('userId').value" (click)="onInvite()">
                <i class="fa fa-paper-plane" aria-hidden="true"></i> {{_(KEYS.CRUD.INVITE_USER)}}
              </button>
              <button type="button" class="btn btn-primary" [disabled]="!userForm.valid" (click)="onSubmit()">
                <i class="fa fa-save" aria-hidden="true"></i> {{_(KEYS.CRUD.SAVE)}}
              </button>
            </div>
          </footer>
        </form>
      </ng-template>
    </li>
    <li [ngbNavItem]="2" [disabled]="!user || !user.userId">
      <a ngbNavLink>{{_(KEYS.CRUD.CHANGE_PASSWORD)}}</a>
      <ng-template ngbNavContent>
        <section class="card qa-uc-card">
          <div class="card-body">
            <app-user-change-password
              [user]="user"
              [passwordPolicy]="passwordPolicy"
              [requireCurrentPassword]="requireCurrentPassword"
              (onPasswordChanged)="this.user = $event;">
            </app-user-change-password>
          </div>
        </section>
      </ng-template>
    </li>
    <li [ngbNavItem]="3" [disabled]="!user || !user.userId || !previewMode || !hasFilterGroupSupport">
      <a ngbNavLink>{{_(KEYS.CRUD.FILTER_GROUPS)}}</a>
      <ng-template ngbNavContent>
        <app-user-filter-group [user]="user"></app-user-filter-group>
      </ng-template>
    </li>
    <li [ngbNavItem]="4" [disabled]="!user || !user.userId">
      <a ngbNavLink>{{_(KEYS.CRUD.PERMISSIONS)}}</a>
      <ng-template ngbNavContent>
        <app-user-permission [user]="user"></app-user-permission>
      </ng-template>
    </li>
    <li *ngIf="hasMfaSupport" [ngbNavItem]="5" [disabled]="!user || !user.userId">
      <a ngbNavLink>2FA</a>
      <ng-template ngbNavContent>
        <app-user-mfa [user]="user"></app-user-mfa>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="qa-uc-outlet"></div>
</div>
